module.exports = __webpack_public_path__ + "static/media/jaeger-logo.a7093b12.svg";